export interface Init {
  jwtToken?: string;
  language?: string | 'en';
}

export interface CloudPayOptions {
  entryId?: string;
  apisessionid: string;
}

export interface ContactSubmissionOptions {
  emailaddress: string;
  body: string;
  subject?: string;
  name?: string;
}

export interface LoginSubmissionForm {
  emailaddress: string;
  password: string;
}

export interface CustomerData {
  UtcNow?: string;
  LocationFromIp?: {
    Name: string;
    Country: string;
    CountryCode: string;
    State: string;
    City: string;
  };
  ModelErrors?: { [x: string]: string; };
  CurrentCustomerSession?: CustomerSessionData;
  CurrentCustomerSessionStatus?: number;
}

export interface CustomerSessionData {
  Id: string;
  CustomerId: string;
  CustomerDeleted: boolean;
  CustomerFirstName: string;
  CustomerLastName: string;
  CustomerEmailAddress: string;
  CustomerSubscriptionCount: number;
  CustomerNonExpiringSubscriptionCount: number;
  CustomerEntitlements: string;
  CustomerFullAccessUntil: any;
  CustomerBillingProfileProvider: any;
  CustomerBillingProfileReference: any;
  CustomerBillingProfileExpiresAt: any;
  CustomerBillingProfileCreatedAt: any;
  CustomerBillingProfileLastFailedAt: any;
  CustomerPackages: string;
}

export interface PaymentResponse extends CustomerData {
  ErrorMessage?: string;
  AuthenticationToken?: string;
  KSession?: string;
  Status?: CloudPayStatus;
  PageUrl?: string;
  UpdatedAt?: string;
  JwtTokenCacheKey?: string;
  Resume?: ResumeData;
}

export enum CloudPayStatus {
  granted = -1,
  noActiveSession,
  noSubscription,
  noEntitlement,
  blocked,
  tooManyRequests,
  error,
  noContent = 'noContent',
  noRegistration = 'NoRegistration'
}

export interface ResumeData {
  Timestamp: number;
}

export interface VoucherCodeValidResponse extends CustomerData {
  IsValid?: boolean;
  IsGift?: boolean;
  OfferVoucherId?: string;
  RedirectUrl?: string;
}

export interface SubscriptionPlan {
  Id?: string;
  Title?: string;
  Body?: string;
  Style?: string;
  Amount?: number;
  Currency?: string;
  AmountFormatted?: string;
  HasFreeTrial?: boolean;
  TrialDuration?: number;
  PurchaseUrl?: any;
  Interval?: string;
  Duration?: number;
}

export interface SubscriptionPackageList extends SubscriptionPlan {
  SubscriptionPlanOptions?: SubscriptionPlan[];
}

export interface SsoParams {
  redirect: string;
}

export interface CloudPayApi {
  init?(data: Init);

  getSubscriptionPackageList?(): Promise<SubscriptionPackageList>;

  getSessionState?(): Promise<PaymentResponse>;

  doLogin?(data: LoginSubmissionForm, loginCallback?: () => void): Promise<PaymentResponse>;

  doLogout?(): Promise<PaymentResponse>;

  doContactSubmission?(options: ContactSubmissionOptions): Promise<PaymentResponse>;

  isEmailAddressValid?(data: { emailaddress: string }): Promise<boolean>;

  isEmailAddressRegistered?(data: { emailaddress: string }): Promise<boolean>;

  isVoucherCodeValid?(data: { code: string }): Promise<VoucherCodeValidResponse>;

  getKSession?(entryId: string): Promise<PaymentResponse>;


  startSSO?(data: SsoParams): Promise<void>;


// doLogin?(data: LoginSubmissionForm, callback?: (data: PaymentResponse) => void): void;
  // doLoginPost?(data: string, callback?: (data: PaymentResponse) => void): any;
  // doContactSubmission?(options: ContactSubmissionOptions, callback?: (data: PaymentResponse) => void): void;
  // getKSession?(data: CloudPayOptions, callback?: (data: PaymentResponse) => void): void;


  // getSessionState?(data: CloudPayOptions, callback?: (data: PaymentResponse) => void): void;
  // getSubscriptionPackageList?(data: CloudPayOptions, callback?: (data: SubscriptionPackageList) => void): void;


}
